import axios from 'axios';
import { axiosConfig } from '@/config/axiosConfig.js';

const axios_config_for_file = {
    'headers': {
        'Cache-Control': 'no-cache'
    } 
}

export function atlas_menu_ajax(client_name) {
    return axios.get(`${client_name}/gallery/gallery_json/`, axiosConfig);
}

export function atlas_newest_data_ajax(path_list){
    return axios.all(path_list.map(async path => {
        try {
            const response = await atlas_newest_data_single_txt_ajax(path)
            return response
        } catch (err) {
            console.warn(err)
        }
    }))
}

export function atlas_newest_data_single_txt_ajax(path) {
    return axios.get(`${path}/latest.txt`, axios_config_for_file)
}